import styled from 'styled-components';
import { Body } from '@workramp/ui';

export const Description = styled(Body)`
  overflow-wrap: anywhere;
`;
